import axios from 'axios';
import type { Club } from '../types/club';
import type { Role } from '../types/user';
import { API_BASE_URL } from '../config/api';

// Create axios instance WITHOUT auth interceptor for public endpoints
const publicApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const publicService = {
  async getAllClubs(): Promise<Club[]> {
    try {
      const response = await publicApi.get('/clubes', {
        headers: {
          'Authorization': undefined
        }
      });
      return response.data.clubs;
    } catch (error: any) {
      throw new Error(error.response?.data?.mensaje || 'Failed to get clubs');
    }
  },

  async getRoles(): Promise<Role[]> {
    try {
      const response = await publicApi.get('/users/roles', {
        headers: {
          'Authorization': undefined
        }
      });
      return response.data.roles;
    } catch (error: any) {
      throw new Error(error.response?.data?.mensaje || 'Error al obtener roles');
    }
  },
};